import {
	IInitialFormData,
	TEditComboGroupVisibleForm,
	TTypeOfEditComboGroupModalWindow,
} from './editComboGroupContext';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, IUpdateComboGroup } from 'types';

export enum EditComboGroupActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	SET_FETCHED_DISHES = 'SET_FETCHED_DISHES',
	SET_DISHES = 'SET_DISHES',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_COMBO_ITEMS = 'SET_FETCHED_COMBO_ITEMS',
	SET_COMBO_ITEMS = 'SET_COMBO_ITEMS',
	CHANGE_UPPER_LIMIT = 'CHANGE_UPPER_LIMIT',
	CHANGE_LOWER_LIMIT = 'CHANGE_LOWER_LIMIT',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditComboGroupActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditComboGroupActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditComboGroupActionTypes.SET_ALL_DATA;
	payload: {
		comboGroupId: string;
		customer: Nullable<string>;
		restaurants: string[];
		dishes: string[];
		name: string;
		comboItems: string[];
		upperLimit: string;
		lowerLimit: string;
		translations: IMenuTranslation[];
	};
}

interface IChangeVisibleForm {
	type: EditComboGroupActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TEditComboGroupVisibleForm;
	};
}

interface ISetFetchedRestaurants {
	type: EditComboGroupActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetRestaurants {
	type: EditComboGroupActionTypes.SET_RESTAURANTS;
	payload: {
		restaurants: string[];
	};
}

interface ISetFetchedDishes {
	type: EditComboGroupActionTypes.SET_FETCHED_DISHES;
	payload: {
		dishes: IItemForGetShortInfo[];
	};
}

interface ISetDishes {
	type: EditComboGroupActionTypes.SET_DISHES;
	payload: {
		dishes: string[];
	};
}

interface IChangeName {
	type: EditComboGroupActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedComboItems {
	type: EditComboGroupActionTypes.SET_FETCHED_COMBO_ITEMS;
	payload: {
		comboItems: IItemForGetShortInfo[];
	};
}

interface ISetComboItems {
	type: EditComboGroupActionTypes.SET_COMBO_ITEMS;
	payload: {
		comboItems: string[];
	};
}

interface IChangeUpperLimit {
	type: EditComboGroupActionTypes.CHANGE_UPPER_LIMIT;
	payload: {
		upperLimit: string;
	};
}

interface IChangeLowerLimit {
	type: EditComboGroupActionTypes.CHANGE_LOWER_LIMIT;
	payload: {
		lowerLimit: string;
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditComboGroupActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: EditComboGroupActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: EditComboGroupActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: EditComboGroupActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateComboGroup | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditComboGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditComboGroupModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditComboGroupActionTypes.RESET_FIELDS;
}

export type TEditComboGroupAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| ISetFetchedRestaurants
	| ISetRestaurants
	| ISetFetchedDishes
	| ISetDishes
	| IChangeName
	| ISetFetchedComboItems
	| ISetComboItems
	| IChangeUpperLimit
	| IChangeLowerLimit
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
